<template>
  <div class="container border rounded-xl p-6 flex flex-col min-h-[280px] max-w-[370px] shadow-sm">
    <div class="text-[16px] text-[#222] mb-6 leading-relaxed">"{{ review }}"</div>
    <div class="flex flex-row items-center mt-auto">
      <template v-if="avatar">
        <img :src="avatar" alt="avatar" class="w-10 h-10 rounded-full object-cover mr-3" />
      </template>
      <template v-else>
        <ProfileIcon :data="{ name: userName }" :size="40" :font="16" class="mr-3" />
      </template>
      <div>
        <div class="font-bold text-[16px] text-[#222]">{{ name }}</div>
        <div class="text-[13px] text-[#888]">{{ designation }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import ProfileIcon from '@/components/custom/ProfileIcon.vue';
const props = defineProps({
  review: String,
  name: String,
  userName: String,
  designation: String,
  avatar: String,
});
</script>

<style scoped>
.container {
  background-color: var(--white-opacity-4);
}
</style>
